<template>
  <div class="filter-type noselect">
    <div class="filter-headline" role="button" @click="showFilters = !showFilters">
      <span class="material-icons float-left" aria-hidden="true">{{ icon }}</span>
      <span class="material-icons float-right" aria-hidden="true" v-show="showFilters">keyboard_arrow_up</span>
      <span class="material-icons float-right" aria-hidden="true" v-show="!showFilters">keyboard_arrow_down</span>
      <strong>{{ title }}</strong>
      <br />{{ subtitle }}
    </div>
    <ul class="filter-type-options" v-show="showFilters">
      <li v-for="(filter, index) in filterArray" :key="index" class="filter-li" @click="toggleFilter(filter.option_id, filter.href, filterArray)">
        {{ filter.name }}
        <span class="material-icons float-right" aria-hidden="true" :class="[filter.checked ? 'blue-text' : 'grey-text']">check</span>
        <input type="checkbox" class="sr-only" :checked="filter.checked" aria-label="Slå filteret til eller fra" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showFilters: false,
    };
  },
  props: {
    filterArray: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
  computed: {},
  methods: {
    toggleFilter(targetId, href, filterArray) {
      //console.log(filterArray);
      //console.log(targetId);
      for (var i = 0; i < filterArray.length; i++) {
        if (filterArray[i].option_id == targetId) {
          //console.log(filterArray[i]);
          if (localStorage.getItem(href) == "true" || localStorage.getItem(href) == null) {
            //console.log('true/null before click');
            localStorage.setItem(href, "false");
            filterArray[i].checked = false;
          } else {
            //console.log('false before click');
            localStorage.setItem(href, "true");
            filterArray[i].checked = true;
          }
        }
      }
      // this.filterPlaces();
      this.$emit("filterToggled");
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-type {
  border-top: 1px solid #ddd;
  padding: 10px;
  cursor: pointer;
}

.filter-headline .material-icons {
  position: relative;
  top: 5px;
  margin-right: 10px;
}

.filter-type-options {
  margin: 10px 0px 0px 10px;
}

.filter-type-options li {
  height: 30px;
  line-height: 30px;
  padding-left: 30px;
  padding-right: 10px;
  vertical-align: middle;
  cursor: pointer;
}
</style>
